// Define mixin
const hashtagShuffle = {
    methods: {
        prepareShuffleString(hashtags, removeDuplicates) {
            var find = "#";
            var re = new RegExp(find, "g");

            var hashtagstoshuffle = hashtags;

            hashtagstoshuffle = hashtagstoshuffle.replace(re, " "); // Replace hashtags with spaces
            hashtagstoshuffle = hashtagstoshuffle.replace(/\s\s+/g, " "); // Replace multiple spaces with single space
            hashtagstoshuffle = hashtagstoshuffle.trim(); // Replace whitespace at start and end of string
            hashtagstoshuffle = hashtagstoshuffle.split(" "); // Create array of single-separated hashtags

            // Check if we should remove duplicates
            if (removeDuplicates) {
                hashtagstoshuffle = [...new Set(hashtagstoshuffle)];
            }

            return hashtagstoshuffle;
        },

        shuffleHashtagSet(hashtags, shuffleCount, removeDuplicates, type) {
            // Switch type and reset errors
            if (type == "global") {
                this.errors = [];
            } else if (type == "modal") {
                this.modalerrors = [];
            }

            // Get hashtags
            var hashtagstoshuffle = this.prepareShuffleString(hashtags, removeDuplicates);

            // Do the shuffle
            this.shuffledhashtags = this.doHashtagShuffle(hashtagstoshuffle, shuffleCount, type);
        },

        doHashtagShuffle(arr, n, type) {
            var result = new Array(n),
                len = arr.length,
                taken = new Array(len);
            if (n > len) {
                var errorMessage = {
                    type: "warning",
                    message:
                        "You're trying to shuffle more hashtags than there are in your hashtag set.",
                };
                if (type == "global") {
                    this.errors.push(errorMessage);
                } else if (type == "modal") {
                    this.modalerrors.push(errorMessage);
                }
                return " ";
            }
            while (n--) {
                var x = Math.floor(Math.random() * len);
                result[n] = arr[x in taken ? taken[x] : x];
                taken[x] = --len in taken ? taken[len] : len;
            }
            return "#" + result.join(" #");
        },
    },
};

// Export
export default hashtagShuffle;
